<template>
	<div>
		<v-card class="mx-auto elevation-12" style="max-width: 500px">
			<v-card-title class="headline font-weight-black">
				<v-spacer></v-spacer>Sign up
				<v-spacer></v-spacer>
			</v-card-title>

			<div class="pa-4 pt-6">
				<v-row>
					<v-col class="sx-6">
						<v-btn
							block
							depressed
							:color="isPractice ? 'primary' : 'grey--lighten-2'"
							:outlined="isPractice ? false : true"
							large
							@click="navigate('/signup/practice')"
							>{{ getLabel('signUpUserTypeButtonCompany', 'Practice') }}</v-btn
						>
						<div class="text-center caption font-weight-bold mt-2">
							{{ getLabel('signUpUserTypeDescriptionCompany', 'Select above if you own/manage a Practice/Hospital') }}
						</div>
					</v-col>
					<v-col class="sx-6">
						<v-btn
							v-model="isLocum"
							block
							depressed
							:color="isLocum ? 'primary' : 'grey--lighten-2'"
							:outlined="isLocum ? false : true"
							large
							@click="navigate('/signup/locum')"
							>{{ getLabel('signUpUserTypeButtonProfessional', 'Locum') }}</v-btn
						>
						<div class="text-center caption font-weight-bold mt-2">
							{{ getLabel('signUpUserTypeDescriptionProfessional', 'Select above if you want to work as a Locum') }}
						</div>
					</v-col>
				</v-row>
			</div>

			<router-view :user-type="userType"></router-view>
		</v-card>
	</div>
</template>

<script>
import { User } from '@/models/user.model';
import { Tracking } from '@/utils/tracking';
import { labelMixin } from '@/mixin/label.mixin';

export default {
	name: 'UserTypeForm',
	mixins: [labelMixin],
	computed: {
		userType() {
			if (this.$route.name === 'SignInPractice') {
				return User.TYPES.PRACTICE.value;
			} else if (this.$route.name === 'SignInLocum') {
				return User.TYPES.LOCUM.value;
			} else return null;
		},

		isLocum() {
			return this.userType === User.TYPES.LOCUM.value;
		},

		isPractice() {
			return this.userType === User.TYPES.PRACTICE.value;
		},
	},

	mounted() {
		Tracking.track('DisplaySignup', {});
	},

	methods: {
		navigate(path) {
			this.$router.push({ path, query: this.$route.query });
		},
	},
};
</script>
